import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps, Typography } from 'components/ui';
import { primitive } from 'styles/constants';

const AlertBox = ({
  children,
  error,
  style,
  ...props
}: React.PropsWithChildren<BoxProps & { error?: boolean }>) =>
  React.createElement(
    Box,
    { ...props, style: [styles.container, error ? styles.error : styles.success, style] },
    React.createElement(
      Typography,
      { style: [styles.text, error ? styles.errorText : styles.successText] },
      children
    )
  );

export const SuccessAlertBox = (props: React.PropsWithChildren<BoxProps>) =>
  React.createElement(AlertBox, props);
export const ErrorAlertBox = (props: React.PropsWithChildren<BoxProps>) =>
  React.createElement(AlertBox, { ...props, error: true });

const styles = StyleSheet.create({
  container: { borderWidth: 1, marginBottom: 20, paddingHorizontal: 24, paddingVertical: 8 },
  error: { borderColor: primitive.$greyEight },
  success: { borderColor: primitive.$fieryRed },
  text: { fontSize: 16, textAlign: 'center' },
  errorText: { color: primitive.$greyEight },
  successText: { color: primitive.$fieryRed, fontFamily: 'heading' },
});
